import { Modal, Container } from "react-bootstrap";
import React from "react";
import ReactLoading from "react-loading";

//css
import "./Modal.css";

function AddModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered backdrop="static">
        <Modal.Header />
        <Modal.Body>
          <div className="col-sm-12">
            <text className="custom-modal-body-title"> ADD {props.title} </text>
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>

            <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-secondary me-3" onClick={props.onHide}>
                Cancel
              </button>
              {props.loader ? (
                <div className="button-tertiary me-3 d-flex justify-content-center">
                  <ReactLoading
                    type="bubbles"
                    color="var(--primary-color)"
                    height={50}
                    width={50}
                  />
                </div>
              ) : (
                <button className="button-primary" onClick={props.onSave}>
                  Save
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

AddModal.defaultProps = {
  title: "",
  // type:"",
  size: "xl",
  show: () => {},
  onHide: () => {},
  onSave: () => {},
};

export default AddModal;
